import { blue } from "@ant-design/colors";
import { 
    AlignLeftOutlined, 
    CalendarOutlined, 
    CheckSquareOutlined, 
    EditOutlined, 
    FileImageOutlined, 
    FontSizeOutlined, 
    HomeOutlined, 
    LinkOutlined, 
    NumberOutlined, 
    PaperClipOutlined, 
    ProfileOutlined, 
    TableOutlined, 
    UnorderedListOutlined 
} from "@ant-design/icons";

// Icon mapping for serializable icon identifiers
const iconMap = {
    edit: EditOutlined,
    fontSize: FontSizeOutlined,
    alignLeft: AlignLeftOutlined,
    checkSquare: CheckSquareOutlined,
    unorderedList: UnorderedListOutlined,
    calendar: CalendarOutlined,
    number: NumberOutlined,
    paperClip: PaperClipOutlined,
    home: HomeOutlined,
    link: LinkOutlined,
    profile: ProfileOutlined,
    fileImage: FileImageOutlined,
    table: TableOutlined,
    switch: 'switch' // Special case for custom SVG
};

// Function to render icon based on identifier
export const renderIcon = (iconId, style = {}) => {
    const defaultStyle = { color: blue.primary, fontSize: "1.2rem", ...style };
    
    if (iconId === 'switch') {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30px"
                height="15px"
                fill="none"
                viewBox="5.5 7 12 12"
            >
                <path
                    d="M17 17H7C4.51 17 2.5 14.99 2.5 12.5C2.5 10.01 4.51 8 7 8H17C19.49 8 21.5 10.01 21.5 12.5C21.5 14.99 19.49 17 17 17Z"
                    stroke={blue.primary}
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.42737 15C8.80808 15 9.92737 13.8807 9.92737 12.5C9.92737 11.1193 8.80808 10 7.42737 10C6.04666 10 4.92737 11.1193 4.92737 12.5C4.92737 13.8807 6.04666 15 7.42737 15Z"
                    stroke={blue.primary}
                    strokeMiterlimit="10"
                />
            </svg>
        );
    }
    
    const IconComponent = iconMap[iconId];
    if (!IconComponent) {
        return null;
    }
    
    return <IconComponent style={defaultStyle} />;
};

// Helper function to get icon identifier from component (for migration purposes)
export const getIconId = (iconComponent) => {
    // This is a helper for identifying existing icons during migration
    // In practice, you'd use the icon identifiers directly
    return null;
};
